import { deleteRequest } from '..';

const deleteUser = (userId: string) => deleteRequest(`users/v2/${userId}`, { userId });

export default deleteUser;
